import type { Ref, RefObject } from "react";

export function assertRefObject<T>(
  ref: Ref<T>
): asserts ref is RefObject<T> | null {
  if (ref && !("current" in ref)) {
    throw new Error("assertRefObject(): Only RefObject's are supported.");
  }
}
